import { SVGProps } from 'react';

const ShareScaleSmall = (props: SVGProps<SVGSVGElement>) => (
    <svg width={17} height={17} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M14.7272 9.22272C14.9001 9.0745 14.9866 9.0004 15.0183 8.91221C15.0461 8.83481 15.0461 8.75014 15.0183 8.67274C14.9866 8.58455 14.9001 8.51044 14.7272 8.36223L8.72712 3.21929C8.42945 2.96415 8.28062 2.83658 8.15462 2.83345C8.04511 2.83074 7.9405 2.87885 7.8713 2.96376C7.79167 3.06147 7.79167 3.25749 7.79167 3.64953V6.692C6.2796 6.95653 4.89571 7.72272 3.86729 8.87313C2.74608 10.1273 2.12587 11.7504 2.125 13.4327V13.8662C2.86828 12.9708 3.79632 12.2467 4.84554 11.7433C5.77058 11.2996 6.77054 11.0367 7.79167 10.9674V13.9354C7.79167 14.3275 7.79167 14.5235 7.8713 14.6212C7.9405 14.7061 8.04511 14.7542 8.15462 14.7515C8.28062 14.7484 8.42945 14.6208 8.72712 14.3657L14.7272 9.22272Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.41667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ShareScaleSmall;
